import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "features/layout/components";

import ErrorPlaceholder from "common/components/ErrorPlaceholder";

import useLeadLists from "../../datahooks/useLeadLists";
import LeadListCreate from "./LeadListCreate";
import LeadListsGrid from "./LeadListsGrid";

export default function AllLists() {
  const { leadLists, isLoadingLeadLists, leadListsError, refetchLeadLists } =
    useLeadLists();

  return (
    <ContentContainer>
      <ContentHeader>
        {/* Page title */}
        <PageTitle />

        {/* Create list button */}
        <LeadListCreate />
      </ContentHeader>

      <ContentScroll className="p-4 gap-4 lg:gap-6">
        {leadListsError ? (
          <ErrorPlaceholder
            errorMessage="Could not display Lists"
            onRetry={refetchLeadLists}
          />
        ) : (
          <LeadListsGrid
            isLoading={isLoadingLeadLists}
            leadLists={leadLists || []}
          />
        )}
      </ContentScroll>
    </ContentContainer>
  );
}
